module.exports = __webpack_public_path__ + "img/card_bj@2x.47041b0f.png";